import { CONFIG } from '../../../config'

const { ENVIROMENT } = CONFIG
const BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/cte/mdfe`

//Mdfe
export function urlGetMdfeTpId(tpId, pInicial, pFinal) {
  const params = []

  if (tpId) params.push(`tp_id=${tpId}`)
  if (pInicial) params.push(`pInicial=${pInicial}`)
  if (pFinal) params.push(`pFinal=${pFinal}`)

  if (params.length) return `${BASE_URL}?${params.join('&')}`

  return BASE_URL
}

export function urlDownloadMdfe(mdfes_id) {
  // Download aberto em nova aba: token vai por query string para o authMiddleware
  return `${BASE_URL}/download?mdfes_id=${mdfes_id}&t=${localStorage.getItem('t')}`
}

export const urlDeleteCancelMdfe = `${BASE_URL}/cancel`

export const urlEncerrarMdfe = `${BASE_URL}/encerrar`

export const urlSyncMdfe = `${BASE_URL}/sync`

export function urlRotaParaMdfe(fleetId) {
  return `${BASE_URL}/rota?fleet_id=${fleetId}`
}

export function urlVeiculoSugeridoMdfe(ctesIds) {
  return `${BASE_URL}/veiculo-sugerido?ctes_ids=${ctesIds.join(',')}`
}

export const urlBaseMdfe = BASE_URL

export function urlDocumentosRotaMdfe(fleetId) {
  return `${BASE_URL}/rota/documentos?fleet_id=${fleetId}`
}

export function urlMdfesDisponiveisVinculo(fleetId) {
  return `${BASE_URL}/disponiveis-vinculo?fleet_id=${fleetId}`
}

export const urlVincularRotaMdfe = `${BASE_URL}/vincular-rota`
